import "./userTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Delete, Edit, Add } from "@mui/icons-material";

const UserTable = () => {
  //global userId and adminType to controller access
  const userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);

  let alias = 0;
  if (adminType === "sAdmin") {
    alias = 1;
  }

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState(null);

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          BASE_URL + "/api/users/findAllAdminUser" + `/${alias}`,
        );
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchUsers();
  }, [BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        BASE_URL + `/api/users/deleteAdminUser/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = (userData) => {
    navigate("/users/newUser", { state: { user: userData } }); // Pass user data to NewUser
  };

  const userListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "villageImage",
      headerName: "User",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
            <img
              className="cellImg"
              src={params.row.villageImage?.url}
              alt="avatar"
            />
            {params.row.villageName}
          </div>
        );
      },
    },
    {
      field: "clubName",
      headerName: "Club Name",
      width: 250,
    },
    {
      field: "district",
      headerName: "District",
      width: 100,
    },
    {
      field: "palika",
      headerName: "UM/RM",
      width: 200,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {adminType !== "Admin" && (
              <IconButton color="primary" aria-label="add">
                <Link to="/users/newUser" style={{ textDecoration: "none" }}>
                  <Add />
                </Link>
              </IconButton>
            )}
            {adminType !== "Admin" && (
              <IconButton
                onClick={() => handleUpdate(params.row)}
                color="primary"
                aria-label="update"
              >
                <Edit />
              </IconButton>
            )}
            {adminType !== "Admin" && (
              <IconButton
                onClick={() => {
                  setSelectedUsers(params.row);
                  setOpenDialog(true);
                }}
                color="error"
                aria-label="delete"
              >
                <Delete />
              </IconButton>
            )}
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedUsers(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedUsers) {
      await handleDelete(selectedUsers._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Users
        </Typography>
        <Link to="/users/newUser">
          {adminType !== "Admin" && (
            <Button variant="contained" color="primary">
              Add Users
            </Button>
          )}
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={userListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Users?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserTable;
